import MobileSlider from "./mobile-slider";
import StatCard from "./StatCard";

type softwareProps = {
  data?: any;
  isMobile?: boolean;
};

const Work: React.FC<softwareProps> = ({ data, isMobile: _isMobile  }) => {
  return (
    <section className="xl:py-[100px] md:py-[80px] py-[56px] bg-[linear-gradient(96.18deg,_#E6F5FF_0%,_#5AA7DF_100%)] relative">
      {/* Background overlays */}
      <div className=" bg-[linear-gradient(0deg,_rgba(255,_255,_255,_0.8),_rgba(255,_255,_255,_0.8))] absolute z-[1] top-0 left-0 inset-0"></div>
      <div className=" bg-[url(/images/enterprise-bg.png)] bg-size-[60%] bg-no-repeat bg-left-top absolute z-[2] top-0 left-0 inset-0"></div>

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          <h2 className="text-heading-1 font-bold text-center text-primary-text md:text-left md:mb-[16px] mb-[12px]">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 font-normal text-secondary-text mb-[40px] max-w-[940px] mx-auto">
            {data?.description}
          </p>

          {/* Desktop Grid */}
          <div className="md:grid-cols-12 gap-6 md:gap-[40px] items-start w-full sm:grid hidden">
            {data?.impect_cards?.map((card: any, index: number) => (
              <div key={card.id || index} className="sm:text-left xl:col-span-12 md:col-span-12">
                <StatCard data={card} />
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Slider */}
        <div className="block sm:hidden w-full">
          <MobileSlider>
            {data?.impect_cards?.map((card: any, index: number) => (
              <div key={card.id || index} className="w-full">
                <StatCard data={card} />
              </div>
            ))}
          </MobileSlider>
        </div>
      </div>
    </section>
  );
}

export default Work;
